<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <!-- post START here -->
        <div v-for="post in posts" :key="post.id" class="post">
          <h3>{{ post.title }}</h3>
          <div class="meta">
            <span class="category">{{ post.category.category }}</span>
            <span class="date">{{ post.date }}</span>
          </div>
          <p v-html="post.content"></p>
        </div>
        <button v-if="!hideMore" class="big-btn blue" @click.prevent="next()">
          More ->
        </button>
      </div>
      <!-- sidebar START here -->
      <div id="sidebar">
        <ul>
          <!-- widget START here -->
          <li class="widget">
            <div class="title">
              <h5>Categories</h5>
            </div>
            <div class="content">
              <ul>
                <li v-for="cat in categories" :key="cat.id">
                  <a href="" @click.prevent="catClick(cat)">{{
                    cat.category
                  }}</a>
                </li>
              </ul>
            </div>
          </li>
          <!-- widget END here -->
          <!-- widget START here -->
          <li class="widget">
            <div class="title">
              <h5>Archives</h5>
            </div>
            <div class="content">
              <ul>
                <li v-for="archive in archives" :key="archive.id">
                  <a
                    href=";javascript"
                    @click.prevent="archiveClick(archive)"
                  >{{ archive.month + " " + archive.year }}</a>
                </li>
              </ul>
            </div>
          </li>
          <!-- widget END here -->
          <adsense
            ad-client="ca-pub-8213113866781504"
            ad-slot="7997332272"
            ad-style="display:inline-block;width:250px;height:250px"
            ad-format="auto"
          >
          </adsense>
          <adsense
            ad-client="ca-pub-8213113866781504"
            ad-slot="9157837875"
            ad-style="display:inline-block;width:160px;height:600px"
            ad-format="auto"
          >
          </adsense>
        </ul>
      </div>
      <!-- sidebar END here -->
    </div>
  </div>
</template>

<script>
import PostRepository from "../data/post.repository.js";
import Adsense from "../components/adsense.vue";
export default {
  components: {
    adsense: Adsense,
  },
  data() {
    return {
      posts: [],
      archives: [],
      category: "",
      month: "",
      year: "",
      page: 0,
      total: 0,
      current: 0,
    };
  },
  computed: {
    categories() {
      return this.$store.state.categories;
    },
    hideMore() {
      return this.current >= this.total;
    },
  },
  created() {
    this.next();
    PostRepository.archives().then((data) => {
      this.archives = data;
      this.current = data.to;
      this.page = data.current_page;
      this.records = data.data;
    });
  },
  methods: {
    next() {
      if (this.current >= this.total && this.page !== 0) return;
      PostRepository.get(
        this.page + 1,
        this.category,
        this.month,
        this.year
      ).then((data) => {
        this.total = data.total;
        this.current = data.to;
        this.page = data.current_page;
        this.posts = this.posts.concat(data.data);
      });
    },
    catClick(cat) {
      this.category = cat.id;
      this.month = "";
      this.year = "";
      PostRepository.get(1, cat.id).then((data) => {
        this.posts = data.data;
        this.current = data.to;
        this.page = data.current_page;
        this.total = data.total;
      });
    },
    archiveClick(archive) {
      this.category = "";
      this.month = archive.month;
      this.year = archive.year;
      PostRepository.get(1, null, archive.month, archive.year).then((data) => {
        this.posts = data.data;
        this.current = data.to;
        this.page = data.current_page;
        this.total = data.total;
      });
    },
  },
  metaInfo: {
    title: "Blog",
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Blog.vue?b3c77b9a